import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { ThemeContext, LanguageContext, UserContext } from "../../contexts/Context";
import axios from "axios";
import { IoCloseOutline } from "react-icons/io5";
import { getAssetUrl } from "./loginDisplayUtil";

const CustomerForgot = ({ show, setShow, setError, setShowError }) => {
    const [displayShow, setDisplay] = useState(show ? "flex" : "none");

    const themeContext = React.useContext(ThemeContext);
    const languageContext = React.useContext(LanguageContext);
    const { lanIndex, token, userId, company, bgImg } = React.useContext(UserContext);

    const [email, setEmail] = useState("");

    useEffect(() => {
        setDisplay(show ? "flex" : "none");
    }, [show]);


    const handleChange = (value) => {
        setEmail(value);
    };
    const submitForgot = () => {
        if (token && userId && show) {
            axios.post(`/v2/api/customer/forgotPwd`, { email }, {
                headers: { Authorization: "Bearer " + token },
            })
                .then(function (response) {
                   
                    if (response.status === 200) {
                        setError([{ errorMessage: "An email has sent to your mailbox. Please check" }]);
                        setShowError(true);
                    }

                })
                .catch(function (error) {
                    //show warning
                 
                    if (error.response && error.response.status === 402) {
                        setError([{ errorMessage: "Email cannot be found. Please contact staff for assistance" }]);
                        setShowError(true);
                    } else {
                       
                        setError([{ errorMessage: "Something went wrong. Please try again" }]);
                        setShowError(true);
                    }
                })


        }
    }

    return (
        <React.Fragment>
            <ModalContainer display={displayShow} bgImg={bgImg} themeContext={themeContext}>
                <IconButton onClick={() => {
                    setShow(false);
                    setDisplay("none");
                }}>
                    <IoCloseOutline size={34} />
                </IconButton>
                <ContentWrapper>
                    <FormSection>
                        <ImgWrapper image={company && company.companyLogo} />
                        <TitleText>FORGOT PASSWORD</TitleText>
                        <Input
                            value={email}
                            type="email"
                            onChange={(e) => { handleChange(e.target.value) }}
                            placeholder={`${languageContext[lanIndex].email}*`}
                            aria-label={languageContext[lanIndex].email}
                        />
                        <SubmitButton onClick={() => {
                            submitForgot();
                        }} >
                            {languageContext[lanIndex].ok}
                        </SubmitButton>
                    </FormSection>
                </ContentWrapper>
            </ModalContainer>

        </React.Fragment >
    );
}

export default CustomerForgot;

const SubmitButton = styled.div`
    display: flex;
    width: 68%;
    max-width: 360px;
    min-height: 62px;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    font-weight: 400;
    border-radius: 34px;
    background-color: #5f5f5f;
    color: #ffffff;
    box-shadow: 0px 2px 5px rgba(0,0,0,0.18);
    cursor: pointer;

    @media (max-height: 760px) {
        min-height: 54px;
        font-size: 21px;
    }
`;

const Input = styled.input`
    width: 100%;
    min-height: 76px;
    border-radius: 12px;
    padding: 0 26px;
    font-size: 24px;
    border: 1px solid #9d9d9d;
    margin-bottom: 18px;
    background-color: rgba(255,255,255,0.94);
    color: #343434;
    box-sizing: border-box;
    outline: none;

    &::placeholder {
        color: #a9a9a9;
    }

    @media (max-height: 760px) {
        min-height: 62px;
        font-size: 20px;
        margin-bottom: 12px;
    }
`;

const ImgWrapper = styled.div`
    width: 220px;
    max-width: 78%;
    height: 110px;
    margin: 0 0 20px;
    background-image: ${(props) => props.image ? `url(${getAssetUrl(props.image)})` : "none"};
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    @media (max-height: 760px) {
        width: 180px;
        height: 88px;
        margin-bottom: 14px;
    }
`;


const IconButton = styled.div`
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 99;
    color: #555555;
    cursor: pointer;
`;

const TitleText = styled.div`
    margin-bottom: 28px;
    color: #333333;
    font-size: 30px;
    font-weight: 300;
    line-height: 1;

    @media (max-height: 760px) {
        margin-bottom: 20px;
        font-size: 26px;
    }
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: 100dvh;
    box-sizing: border-box;
    padding: 44px 32px 34px;
    overflow-y: auto;
`;

const FormSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 500px;
    padding-top: 16px;
`;

const ModalContainer = styled.div`
    display: ${(props) => props.display};
    font-family: "contralto-xsmall", sans-serif;
    position: fixed;
    flex-direction: column;
    background-color: ${(props) => props.themeContext.backgroundColor};
    background-image: ${(props) => props.bgImg ? `url(${getAssetUrl(props.bgImg)})` : "none"};
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    top: 0;
    left: max(0px, calc((100vw - 550px) / 2));

    width: 100vw;
    max-width: 550px;
    height: 100vh;
    height: 100dvh;
    z-index: 9;

    *, input, button, textarea, select {
        font-family: "contralto-xsmall", sans-serif !important;
    }

    animation: modalOrder .1s;
    animation-timing-function: ease-out;
    @keyframes modalOrder {
        0%  {
        transform: translateY(350px);
        opacity: 0;
        }
        
        100%  {
        transform: translateY(0px);
        opacity: 1;
        }
        
    }
  `;

